import { TextFieldWidget } from '@tableau/widgets';
import * as React from 'react';
import { Messages } from '../../../../codegen/Localize';

const testId = 'definition-subspace-values-toolbar';

export interface DefinitionSubspaceValuesControlsProps {
  searchText: string;
  onChangeSearch: (searchText: string) => void;
}

export const DefinitionSubspaceValuesControls = (props: DefinitionSubspaceValuesControlsProps) => {
  return <TextFieldWidget
    kind={'search'}
    label={undefined}
    onChange={e => props.onChangeSearch(e.target.value)}
    onClear={() => props.onChangeSearch('')}
    value={props.searchText}
    testId={testId}
    placeholder={Messages.dataRoleDefinitionSubspace_Values_SearchValues()}/>;
};
